//console.log('header-menu-scroll.js loaded');

class HeaderMenuScroller {
  constructor(menu) {
    this.menu = menu;
    //console.log('HeaderMenuScroller initialized:', menu.id);
    this.wrapper = menu.closest('[data-scrollable-menu-wrapper]');
    this.details = menu.closest('details');
    this.visibleItems = Number(menu.dataset.visibleItems || 5);

    this.upButton = this.wrapper?.querySelector('[data-menu-scroll-up]');
    this.downButton = this.wrapper?.querySelector('[data-menu-scroll-down]');

    if (
      !this.wrapper ||
      !this.details ||
      !this.upButton ||
      !this.downButton
    ) {
      return;
    }
    //console.log('Scroller fully connected:', this.menu.id);
    this.bindEvents();

    /*
     * Only measure immediately when the menu is already open.
     * Normally it will be measured by the toggle event.
     */
    if (this.details.open) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.setVisibleHeight();
          this.updateButtons();
        });
      });
    }
  }

  bindEvents() {
    this.upButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (
        this.upButton.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      this.scrollByOneItem(-1);
    });

    this.downButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (
        this.downButton.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      this.scrollByOneItem(1);
    });

    /*
     * Prevent Shopify's details handlers from reacting to
     * mouse actions on the scroll buttons.
     */
    this.upButton.addEventListener('mousedown', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    this.downButton.addEventListener('mousedown', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });

    this.menu.addEventListener(
      'scroll',
      () => {
        this.updateButtons();
      },
      { passive: true }
    );

    this.details.addEventListener('toggle', () => {
       /*console.log(
          'Menu toggled:',
          this.menu.id,
          'open:',
          this.details.open
        );*/
      if (!this.details.open) {
        this.resetMenu();
        return;
      }

      /*
       * Close any other top-level desktop dropdown.
       */
      document
        .querySelectorAll(
          '.header__inline-menu > .list-menu > li > details[open]'
        )
        .forEach((openDetails) => {
          if (openDetails !== this.details) {
            openDetails.removeAttribute('open');
          }
        });

      /*
       * Start this dropdown at the top each time.
       */
      this.menu.scrollTop = 0;

      /*
       * Close nested category sections before measuring.
       */
      this.menu
        .querySelectorAll('.header__submenu-details[open]')
        .forEach((nestedDetails) => {
          nestedDetails.removeAttribute('open');
        });

      /*
       * Remove any old measurement before recalculating.
       */
      this.menu.style.removeProperty(
        '--header-submenu-items-height'
      );

      /*
       * Wait for the browser and Shopify theme to complete
       * the dropdown layout before measuring the rows.
       */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.setVisibleHeight();
          this.updateButtons();
        });
      });
    });

    window.addEventListener('resize', () => {
      if (!this.details.open) {
        return;
      }

      requestAnimationFrame(() => {
        this.setVisibleHeight();
        this.updateButtons();
      });
    });
  }

  getItems() {
    return Array.from(this.menu.children).filter(
      (element) => element.tagName === 'LI'
    );
  }

  setVisibleHeight() {

      /* console.log(
    'setVisibleHeight called:',
    this.menu.id,
    'open:',
    this.details.open
    ); */

    /*
     * Hidden dropdowns cannot be measured reliably.
     */
    if (!this.details.open) {
      return;
    }

    const items = this.getItems();

    if (!items.length) {
      return;
    }

    const visibleCount = Math.min(
      this.visibleItems,
      items.length
    );

    const visibleItems = items.slice(0, visibleCount);
    //console.log("MENU:", this.menu.id);
 

  //console.log("Items found:", items.length);

  /*items.forEach((item, i) => {
      console.log(
          i,
          item.offsetHeight,
          item.innerText.trim()
      );
  });*/
    /*
     * Add the actual height of each visible row.
     */
    const itemsHeight = visibleItems.reduce(
      (total, item) => total + item.offsetHeight,
      0
    );

    const menuStyles = window.getComputedStyle(this.menu);

    const paddingTop =
      parseFloat(menuStyles.paddingTop) || 0;

    const paddingBottom =
      parseFloat(menuStyles.paddingBottom) || 0;

    const calculatedHeight =
      itemsHeight + paddingTop + paddingBottom;

    /*
     * Do not store a broken measurement.
     */
    if (
      !Number.isFinite(calculatedHeight) ||
      calculatedHeight <= 10
    ) {
      return;
    }

    this.menu.style.setProperty(
      '--header-submenu-items-height',
      `${Math.ceil(calculatedHeight)}px`
    );
  }

  resetMenu() {
    this.menu.scrollTop = 0;

    this.menu
      .querySelectorAll('.header__submenu-details[open]')
      .forEach((nestedDetails) => {
        nestedDetails.removeAttribute('open');
      });

    this.menu.style.removeProperty(
      '--header-submenu-items-height'
    );

    this.updateButtons();
  }

  scrollByOneItem(direction) {
    const items = this.getItems();

    if (!items.length) {
      return;
    }

    const menuTop = this.menu.getBoundingClientRect().top;
    const tolerance = 4;

    let target;

    if (direction > 0) {
      target = items.find((item) => {
        const itemTop =
          item.getBoundingClientRect().top - menuTop;

        return itemTop > tolerance;
      });

      target = target || items[items.length - 1];
    } else {
      target = [...items].reverse().find((item) => {
        const itemTop =
          item.getBoundingClientRect().top - menuTop;

        return itemTop < -tolerance;
      });

      target = target || items[0];
    }

    const targetHeight = Math.max(
      target.getBoundingClientRect().height,
      40
    );

    this.menu.scrollBy({
      top: direction * targetHeight,
      behavior: 'smooth'
    });
  }

  updateButtons() {
    const maximumScroll =
      this.menu.scrollHeight - this.menu.clientHeight;

    const atTop = this.menu.scrollTop <= 1;

    const atBottom =
      maximumScroll <= 1 ||
      this.menu.scrollTop >= maximumScroll - 1;

    this.upButton.setAttribute(
      'aria-disabled',
      atTop ? 'true' : 'false'
    );

    this.downButton.setAttribute(
      'aria-disabled',
      atBottom ? 'true' : 'false'
    );

    this.upButton.classList.toggle(
      'is-disabled',
      atTop
    );

    this.downButton.classList.toggle(
      'is-disabled',
      atBottom
    );
  }
}

function initializeHeaderMenuScrollers(root = document) {
  root
    .querySelectorAll('[data-scrollable-menu]')
    .forEach((menu) => {
      if (menu.dataset.scrollerInitialized === 'true') {
        return;
      }

      menu.dataset.scrollerInitialized = 'true';

      new HeaderMenuScroller(menu);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeHeaderMenuScrollers();
  });
} else {
  initializeHeaderMenuScrollers();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeHeaderMenuScrollers(event.target);
});